import { defineAsyncComponent } from 'vue';

export { useRetrospectiveLinkingStore } from './stores/retrospectiveLinkingStore';
export {
	PURCHASE_DOCUMENT,
	LINK_TARGET,
	type PurchaseDocument,
	type LinkTarget,
	type RetrospectiveLink,
	type RetrospectiveLinkingSettledChange,
	type FinanceDocumentType,
	type FinanceDocumentLineType,
	type LinkingPayload,
} from './types';

export const retrospectiveLinkingMicroFrontends = {
	RetrospectiveLinkingModal: defineAsyncComponent(
		() =>
			import('./components/RetrospectiveLinkingModal/RetrospectiveLinkingModal.vue')
	),
};
